// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"ab268445","276":"5b203260","555":"a61ae31f","658":"f5a91734","771":"56768f6b","818":"1a898f84","900":"93d091da"}[chunkId] + ".chunk.js";
};